<template lang="pug">
	div
		div.searchbox-map-buttons(v-show="!currentComponent")

			div.float-box-btn-group(v-for="buttonGroup in buttons")
				
				div.float-box-btn(v-for="button in buttonGroup", 
						@click="callAction(button)",
						:title="button.name")

					i(:class="button.iconClass")

		//- Componente de ferramentas à esquerda do mapa
		div#searchbox.float-box(:class="{ hidden: !expanded }")
			
			//- Barra vertical com os botões sempre visíveis
			div.searchbox-buttons-bar

				div.searchbox-btn(@click="toogle()", v-show="currentComponent")
					i.mdi(:class="{ 'mdi-menu-left': this.expanded, 'mdi-menu-right': !this.expanded }") 
				
			//- Coluna de conteúdo que pode ser oculta
			div.searchbox-view.float-box-view(:class="{ 'level-1': registroVisivel }")

				i.action-icon.mdi.mdi-window-close.float-box-collapse-icon(@click="closeComponent()")

				//- Renderizando cada um dos componentes configurados
				component(v-for="comp in viewComponents", 
						:is="comp", 
						:ref="comp.name",
						:key="comp.name",
						v-if="comp.name === currentComponent")

</template>

<script>

import FloatBox from '@/components/FloatBox';
import VisualizacaoRegistroCamada from './VisualizacaoRegistroCamada';

export default {
	name: 'SearchBox',
	extends: FloatBox,

	components: { VisualizacaoRegistroCamada },

	data () {
		return {
			expanded: false,
			viewComponents: [],
			currentComponent: null,
			registroVisivel: false,
			registro: null
		};
	},

	created () {
		this.configureComponent(VisualizacaoRegistroCamada);
	},

	methods: {

		closeComponent () {
			
			this.closeCurrentComponent();
			
			if (this.registroVisivel) {
				this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
			}
		}
	}
};

</script>

<style lang="scss" scoped>

@import "../styles/mixins";
@import "../styles/variaveis";

.searchbox-map-buttons {
	position: absolute;
	left: 15px;
	top: 0;
	display: block;
	z-index: 10000;
}

#searchbox {
	left: 0;
	width: $searchbox-view-width;

	&.hidden {
		transform: translateX(-$searchbox-view-width); // s

		.searchbox-view {
			@include box-shadow-none();
		}
	}
	
	.searchbox-view {
		@include box-shadow(2px, 4px, 4px, rgba(0, 0, 0, 0.4)); // TODO extrair	
	}

	.searchbox-buttons-bar {
		position: absolute;
		left: $searchbox-btn-margin-left + $searchbox-view-width;
		top: 0;
		display: block;
		z-index: 10010;
	}

	.searchbox-btn {
		@include box-shadow(2px, 4px, 4px, rgba(0, 0, 0, 0.4)); // TODO extrair
		padding: 0;
		margin-top: $searchbox-btn-margin-top;
		width: $searchbox-btn-width;
		height: $searchbox-btn-height;
		text-align: center;
		vertical-align: middle;
		line-height: $searchbox-btn-height;
		background-color: $searchbox-btn-bg-color;
		color: $searchbox-btn-icon-color;
		cursor: pointer;
		@include border-radii(0, $searchbox-btn-radius, $searchbox-btn-radius, 0);
	
		font-size: $searchbox-btn-icon-size;
		
		&:hover {
			background-color: $searchbox-btn-hover-bg-color;
			color: $searchbox-btn-hover-icon-color;
		}
	}

}

</style>



// WEBPACK FOOTER //
// SearchBox.vue?4906f002